/*eslint-disable*/
export default {
  init() {
    // ===== HAMBURGER MENU =====
    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      $('html').toggleClass('menu-open');
      $('html').ontouchend = (e) => {
        e.preventDefault();
      }
    });

    function accordian(e) {
      console.log('slt');

      let action = 'click';
      let speed = "500";

      $('.c-builder__faq__title').on(action, function () {
        $(this).next().slideToggle(speed).siblings('.c-builder__faq__single-text').slideUp();
        $(this).toggleClass('clicked').siblings('.c-builder__faq__title').removeClass('clicked');

        let img = $(this).children('svg');
        $('svg').not(img).removeClass('rotate');
        img.toggleClass('rotate');
      });
      e.preventDefault();
    }
    accordian();



    $( ".gallery__container .wysiwyg iframe" ).wrap( "<div class='video-wysiwyg'></div>" );

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageWinterTemplateBuilder.js